
import { keyframesFadeIn } from '../../../shared/utilities/styleUtils'
import { u, styled } from '../../../shared/theming-sc'

const FilterDrawerWrapper = styled.div`
    width: 100%;
    float: left;
    background: white;
    padding: 0;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    animation: ${keyframesFadeIn} 0.25s ease-out;

    ${u.media.greaterThan('md')`
       position: relative;
       top: auto;
       bottom: auto;
       left: auto;
       right: auto;
    `};

    ${u.media.lessThan('md')`
      z-index: 21;
    `};
  
`

const FilterDrawerHeader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: white;
    padding: ${u.getSpacing('large')}px;
    box-sizing: border-box;
    z-index: 100;
    border-bottom: 1px solid ${u.getColor('greyMuted')};

    ${u.media.greaterThan('md')`
       display: none;
  `};
`

const FilterDrawerHeaderClose = styled.a`
     display: block;
     position: absolute;
     top: ${u.getSpacing('large')}px;
     right: ${u.getSpacing('large')}px;
     width: 20px;
     height: 20px;
     color: ${u.getColor('greyDark')}
`

const FilterDrawerBody = styled.div`
    width: 100%;
    padding: ${u.getSpacing('large')}px;

    position: absolute;
    top: 156px;
    bottom: 100px;
    left: 0;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    height: auto;
    max-height: none;

    ${u.media.greaterThan('md')`
        position: relative;
        top: auto;
        bottom: auto;
        left: auto;
        right: auto;
        overflow-x: hidden;
        overflow-y: auto;
        height: auto;
        padding-top: 0;
        max-height: 800px;
  `};
`

const FilterDrawerFooter = styled.div`
    width: 100%;
    padding: ${u.getSpacing('large')}px ${u.getSpacing('small')}px;
    border-top: 1px solid ${u.getColor('greyMuted')};
    float: left;

    position: absolute;
    bottom: 0;
    height: 100px;


    ${u.media.greaterThan('md')`
        height: auto;
        bottom: auto;
        position: relative;
  `};

  ${u.media.greaterThan('sm')`
         padding: ${u.getSpacing('large')}px;
  `};
`

export {
  FilterDrawerHeader,
  FilterDrawerHeaderClose,
  FilterDrawerWrapper,
  FilterDrawerBody,
  FilterDrawerFooter
}
